import { default as manage_45formChc2RqzaUkMeta } from "H:/Project/vana_front/pages/admin/manage-form.vue?macro=true";
import { default as resumeszJG52JDlUwMeta } from "H:/Project/vana_front/pages/admin/resumes.vue?macro=true";
import { default as userspf31dNBqf9Meta } from "H:/Project/vana_front/pages/admin/users.vue?macro=true";
import { default as indextztWNTp8jaMeta } from "H:/Project/vana_front/pages/index.vue?macro=true";
import { default as sign_45inwRWwh1ujj1Meta } from "H:/Project/vana_front/pages/sign-in.vue?macro=true";
export default [
  {
    name: "admin-manage-form",
    path: "/admin/manage-form",
    component: () => import("H:/Project/vana_front/pages/admin/manage-form.vue")
  },
  {
    name: "admin-resumes",
    path: "/admin/resumes",
    component: () => import("H:/Project/vana_front/pages/admin/resumes.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("H:/Project/vana_front/pages/admin/users.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("H:/Project/vana_front/pages/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("H:/Project/vana_front/pages/sign-in.vue")
  }
]